import React, { useState } from 'react'
import { Auth } from 'aws-amplify';
import NameLogo from './img/name-img.png'
import AdminLogo from './img/admin-logo.png'
import 'bootstrap/dist/css/bootstrap.min.css'
import './login.css'

export default function Login(props) {

    const [inputType, setInputType] = useState('password');

    const [errorMessage, setErrorMessage] = useState('');

    const toggleInput = () => {
        setInputType(inputType === 'password' ? 'text' : 'password')
    }


    const [data, setData] = useState({
        number: "",
        password: "",
        loginStatus: false
    });

    const SubmitHandler = async (e) => {

        e.preventDefault();
        const usename = '+91' + e.target.number.value;
        const password = e.target.password.value;

        try {

            await Auth.signIn(usename, password);
            Auth.currentSession().then(data => {
                let idToken = data.getIdToken();

                localStorage.setItem('login', JSON.stringify({
                    login: true,
                    token: idToken['jwtToken'],
                    userInfo: idToken.payload,
                    userId: usename
                }));

                window.location.assign("#/Dashboard");
                window.location.reload();

            })
                .catch(err =>
                    setErrorMessage('Incorrect username or password!')
                );

        } catch (err) {
            setErrorMessage('Incorrect username or password!')
        }


    }

    function handle(e) {
        const newdata = { ...data }
        newdata[e.target.id] = e.target.value
        setData(newdata)
        // on type event check in handle method
    }

    return (
        <div className='login'>
            <div className="login-watermark">
                <img src={NameLogo} alt={NameLogo} />
            </div>
            <div className="login-secrion">
                <div className="login-div">
                    <img width="100" src={AdminLogo} alt={AdminLogo} />
                    <div className="login-box">
                        <div className="head-login">
                            <h2>ADMIN panel</h2>
                            <h1>login</h1>
                        </div>

                        <form onSubmit={SubmitHandler}>
                            {errorMessage && (
                                <p className="error"> {errorMessage} </p>
                            )}
                            <div className="mb-4">
                                <input type="number" onChange={(e) => handle(e)} value={data.number} className="form-control" placeholder="Enter Phone Number" id="number" />
                            </div>


                            <div className="js-show">
                                <input type={inputType} className="js-pass form-control mb-1" value={data.password} onChange={(e) => handle(e)} placeholder="Enter Password" id="password" />
                                <div className="check-login check-theme">
                                    <div className="form-check p-0">

                                        <input onChange={toggleInput} type="checkbox" className="form-check-input js-check" id="show-psd" />
                                        <label className="form-check-label " htmlFor="show-psd">Show Password</label>
                                    </div>
                                    <div className="form-check p-0 d-none">
                                        <input type="checkbox" className="form-check-input" id="remember-psd" />
                                        <label className="form-check-label" htmlFor="remember-psd">Remember password</label>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" className="login-btn">LOGIN</button>

                            {/* <div className="forgot"><a href="#">Forgot Password?</a></div> */}
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
}
